import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAccess } from '../context/AdminAccessContext';
import '../components/admin/AdminRouteGuard.css';

const AdminRoute = ({ children }) => {
  const { adminEnabled, loading, isAuthenticated } = useAdminAccess();
  const location = useLocation();

  if (loading) {
    return (
      <div className="admin-route-guard">
        <div className="admin-route-spinner" />
        <p>Checking admin access…</p>
      </div>
    );
  }

  if (!adminEnabled) {
    return <Navigate to="/" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute;
